import { Modal } from 'antd';
import React, { useRef } from 'react';
import { baseUrVideos } from '../../../../baseUrl';

function StaffKycVModalDetailByid({ open, setOpen, kycVideo }) {
    const videoRef = useRef(null);
  
    const handleClose = () => {
      setOpen(false);
      if (videoRef.current) {
        videoRef.current.pause();
      }
    };
  
    const handleOk = () => {
      handleClose();
    };
  
    const handleCancel = () => {
      handleClose();
    };

    const formattedVideoUrl =
      kycVideo && typeof kycVideo === 'string' && (kycVideo.startsWith('http://') || kycVideo.startsWith('https://'))
        ? kycVideo
        : `${baseUrVideos}${kycVideo || ''}`;
  
    return (
      <>
        <Modal
          title="KYC VIDEO"
          centered
          open={open}
          visible={open}
          onOk={handleOk}
          onCancel={handleCancel}
          afterClose={handleClose}
          destroyOnClose={true}
          className="kyc-modal"
        >
          <div className="video-container text-center">
            {kycVideo ? (
              <video
                src={formattedVideoUrl}
                controls
                autoPlay
                ref={videoRef}
                style={{ width: '100%', maxHeight: '70vh', borderRadius: '8px' }}
              />
            ) : (
              <p className="text-muted py-4 mb-0">KYC Video Not Found</p>
            )}
          </div>
        </Modal>
      </>
    );
}

export default StaffKycVModalDetailByid
